export default __webpack_public_path__ + "static/media/graignes2.b75736c7.jpg";